var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-main',{ref:"googleMap",attrs:{"id":"googleMap"}},[_c('el-row',[_c('el-col',[(Boolean(this.loader) && Boolean(this.map))?[_vm._t("default",null,{"loader":_vm.loader,"map":_vm.map})]:_vm._e()],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }